import { render } from "./BestScores.vue?vue&type=template&id=3b7439b3&scoped=true"
import script from "./BestScores.vue?vue&type=script&lang=js"
export * from "./BestScores.vue?vue&type=script&lang=js"

import "./BestScores.vue?vue&type=style&index=0&id=3b7439b3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b7439b3"

export default script